// extracted by mini-css-extract-plugin
module.exports = {"row":"TRUSTable-module__row___2W02R","trus-table":"TRUSTable-module__trus-table___3hOtH","trusTable":"TRUSTable-module__trus-table___3hOtH"};